import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import {
	createWithdrawRequestThunk,
	getAdminSettingsThunk,
	getUserWithdrawlMiscellanousThunk,
	verifyBankDetailsThunk,
	withdrawalPayoutInvoiceDownloadThunk,
	withdrawlHistoryThunk,
} from './WithdrawlThunk'

const initialState = {
	withdrawlHistoryData: [],
	totalCountOfWithdrawlHistory: 0,
	userWithdrawlMiscellanousData: null,
	adminSettingsData: null,
}

export const getWithdrawlHistoryData = createAsyncThunk('user/getWithdrawlRequestData', withdrawlHistoryThunk)
export const getUserWithdrawlMiscellanous = createAsyncThunk('user/getUserWithdrawlMiscellanous', getUserWithdrawlMiscellanousThunk)

export const getAdminSettingsData = createAsyncThunk('user/getAdminSettingsData', getAdminSettingsThunk)
export const verifyBankDetails = createAsyncThunk('user/verifyBankDetails', verifyBankDetailsThunk)
export const createWithdrawRequest = createAsyncThunk('user/createWithdrawRequest', createWithdrawRequestThunk)

export const downloadWithdrawalPayoutInvoice = createAsyncThunk('user/createWithdrawRequest', withdrawalPayoutInvoiceDownloadThunk)

export const withdrawlSlice = createSlice({
	name: 'withdrawl',
	initialState,
	reducers: {
		// setUserProfileData: (state, action) => {
		// 	state.profileData = action.payload
		// },
	},
	extraReducers: (builder) => {
		builder.addCase(getWithdrawlHistoryData.fulfilled, (state, action) => {
			state.withdrawlHistoryData = action.payload?.data?.data // Update the state with the profile data
			state.totalCountOfWithdrawlHistory = action?.payload?.data?.total // Update the state with the profile data
		})

		builder.addCase(getUserWithdrawlMiscellanous.fulfilled, (state, action) => {
			state.userWithdrawlMiscellanousData = action.payload?.data?.data // Update the state with the profile data
		})
		builder.addCase(getAdminSettingsData.fulfilled, (state, action) => {
			state.adminSettingsData = action?.payload?.data?.data
		})
	},
})
// export const {} = teamsSlice.actions
export default withdrawlSlice.reducer
